import React, {
  useContext,
  useEffect,
  useState
}                             from 'react';
import { historyPropType }    from '~/config/routerPropTypes';
import AddonContext           from './context';
import ModalDelete            from '~/components/ModalDelete';
import { toast }              from 'react-toastify';
import Paper                  from '~/components/Paper';
import MonetizationOn         from '@material-ui/icons/MonetizationOn';
import PaperButtons           from '~/components/PaperButtons';
import Request                from '~/providers/Request';
import GridContainer          from '~/components/GridContainer';
import GridItem               from '~/components/GridItem';
import InputShow              from '~/components/InputShow';
import {
  createAddon,
  editAddon,
  addon
}                             from '~/config/routes';
import { useTranslation }     from 'react-i18next';
import AddonRecord            from '~/records/AddonRecord';
import { AbilityContext }     from '~/contexts/Can';

const attrName = (attr) => AddonRecord.hummanAttributeName(attr);

function ShowAddon({history}) {
  const { t } = useTranslation();
  const [ record, setRecord] = useState(new AddonRecord());
  const { records, addRecords } = useContext(AddonContext);
  const [loading, setLoading] = useState(true);
  const { id } = history.location.route.getParams();
  const [modal, setModal] = useState(false);
  const [partner, setPartner] = useState('');
  const ability = useContext(AbilityContext);

  useEffect(() => {
    if(records && records[id]){
      setRecord( record.updateAttributes(records[id]) );
    }
    setLoading(true);
    Request.get(`/admin/packages/${id}`, {})
      .then( response => {
        setLoading(false);
        addRecords({ data: [response.data] }); //Array para reusar o util de transformar e jogar no contexto.
        setRecord( record.updateAttributes(response.data) );
      })
      .catch( e => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    Request.get('/admin/partner').then((result) => {
      const data = [
        ...result.data,
        {id: null, code: '', name: 'Sem Vínculo'}
      ];

      if (record.get('partner_id')) {
        setPartner(data.find(partner => partner.id === String(record.get('partner_id'))).name);
      }
    });
  }, [record.get('partner_id')]);

  async function handleDelete(){
    setLoading(true);
    Request.del(`/admin/packages/${id}`)
    .then(() => {
      toast.success(t('delete-toast-success'));
      history.push(addon.spec);
    })
    .catch(() => {
      setLoading(false);
      toast.error(t('delete-toast-fail'));
    });
    setModal(false);
  }

  return (
    <>
      <Paper
        Icon={ MonetizationOn }
        iconColor='primary'
        title={t('addon.defSingular')}
        loading={loading}
        actions={<PaperButtons
          id={id}
          setModal={ability.can('delete', 'Addons') ? setModal : null}
          backRoute={addon}
          newRoute={ability.can('new', 'Addons') ? createAddon : null}
          editRoute={ability.can('edit', 'Addons') ? editAddon : null}
        />}
      >
        <GridContainer>
          <GridItem xs={12} md={6}>
            <InputShow
              label={attrName('name')}
              value={record.get('name')}
            />
          </GridItem>
          <GridItem xs={12} md={3}>
            <InputShow
              label={attrName('resources_size')}
              value={record.get('resources_size')}
            />
          </GridItem>

          <GridItem xs={6} md={2}>
            <InputShow
              label={attrName('is_active')}
              value={record.get('is_active')}
              type='boolean'
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} md={3}>
            <InputShow
              label={attrName('lang')}
              value={record.get('lang')}
            />
          </GridItem>

          <GridItem xs={12} md={3}>
            <InputShow
              label={attrName('type')}
              value={t(`addon.type.${record.get('type')}`)}
            />
          </GridItem>

          <GridItem xs={12} md={3}>
            <InputShow
              label={attrName('coin')}
              value={record.get('coin')}
            />
          </GridItem>

          <GridItem xs={12} md={3}>
            <InputShow
              label={attrName('price')}
              value={record.get('price')}
              type='float'
            />
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} md={6}>
            <InputShow
              label={attrName('google_product_id')}
              value={record.get('google_product_id')}
            />
          </GridItem>

          <GridItem xs={12} md={6}>
            <InputShow
              label={attrName('apple_product_id')}
              value={record.get('apple_product_id')}
            />
          </GridItem>

          <GridItem xs={6}>
            <InputShow
              label={attrName('partner_id')}
              value={partner}
            />
          </GridItem>

          <GridItem xs={12} md={3}>
            <InputShow
              label={attrName('period')}
              value={t(`addon.period.${record.get('period')}`)}
            />
          </GridItem>

        </GridContainer>

      </Paper>
      <ModalDelete
        modal={modal}
        onClose={() => {
          setModal(false);
        }}
        name={record.get('name')}
        id={record.get('id')}
        deleteAction={handleDelete}
      />
    </>
  );
}

ShowAddon.propTypes={
  history: historyPropType,
};

export default ShowAddon;
